import { Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    rating: 5,
    comment: 'Best shawarma in Nagercoil! The peri peri flavor is amazing. Highly recommended!',
    date: '2 weeks ago'
  },
  {
    id: 2,
    name: 'Priya S',
    rating: 5,
    comment: 'Love their mojitos and the cafe ambiance. Perfect place to hang out with friends.',
    date: '1 month ago'
  },
  {
    id: 3,
    name: 'Mohammed Ali',
    rating: 4,
    comment: 'Great food at affordable prices. The royal falooda is a must-try!',
    date: '3 weeks ago'
  },
  {
    id: 4,
    name: 'Kavitha R',
    rating: 5,
    comment: 'Quick service and delicious snacks. Open late which is very convenient.',
    date: '1 week ago'
  }
];

export const TestimonialsSection = () => {
  return (
    <section className="section-padding bg-muted/30">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            What Our Customers Say
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
            Real reviews from real people
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="cafe-card p-6">
              <Quote className="w-8 h-8 text-secondary mb-4" />
              <p className="text-foreground mb-4 leading-relaxed">
                {testimonial.comment}
              </p>
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="star-rating text-lg">
                    {i < testimonial.rating ? '★' : '☆'}
                  </span>
                ))}
              </div>
              <div>
                <p className="font-semibold text-foreground">{testimonial.name}</p>
                <p className="text-sm text-muted-foreground">{testimonial.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;